import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "selectionCount", "bulkData", "field", "selectedIds"];

  selectedValues = [];

  checkboxTargetConnected(target) {
    target.checked = this.selectedValues.includes(target.dataset.recordId);
  }

  toggleAll(event) {
    const isChecked = event.target.checked;

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked;
      this.pushRecord(checkbox.dataset.recordId, isChecked);
    });

    this.updateUI();
    this.updateSelectedIds();
  }

  toggleMember(event) {
    const checkbox = event.currentTarget;
    this.pushRecord(checkbox.dataset.recordId, checkbox.checked);

    this.updateUI();
    this.updateSelectedIds();
  }

  pushRecord(recordId, isChecked) {
    if (isChecked) {
      if (!this.selectedValues.includes(recordId)) {
        this.selectedValues.push(recordId);
      }
    } else {
      this.selectedValues = this.selectedValues.filter(id => id !== recordId);
    }
  }

  updateUI() {
    const selectedCount = this.selectedValues.length;

    this.selectionCountTarget.textContent = selectedCount;
    this.bulkDataTarget.classList.toggle("d-none", selectedCount === 0);

    if (this.hasFieldTarget) {
      this.updateFieldUrl();
    }
  }

  updateFieldUrl() {
    const baseUrl = this.fieldTarget.dataset.baseUrl;
    const newUrl = `${baseUrl}?${new URLSearchParams({
      selected_ids: JSON.stringify(this.selectedValues),
      record_id: "",
    }).toString()}`;

    this.fieldTarget.dataset.tomSelectTurboFrameUrlValue = newUrl;

  }

  updateSelectedIds() {
    this.selectedIdsTarget.value = JSON.stringify(this.selectedValues);
  }
}
